import Breadcrumb from "../../components/breadcrumbs/Breadcrumb.vue";
import CriarElementoModal from "./criar/CriarElementoModal.vue";
import EditarElementoModal from "./editar/EditarElementoModal.vue";
import StandardPagination from "../../components/pagination/StandardPagination.vue";
import ActionButtons from "../../components/actions/ActionButtons.vue";
import { ElementoService } from "../../services/ElementoService";
import { ExercicioService } from "../../services/ExercicioService";
import TextField from "../../components/fields/textField/TextField.vue";

export default {
    name: "GerenciarElementos",
    components: {
        Breadcrumb,
        CriarElementoModal,
        EditarElementoModal,
        StandardPagination,
        ActionButtons,
        TextField
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Elementos',
                disabled: true
            }
        ],
        // Controle de responsividade
        isMobile: false,
        isTablet: false,
        windowWidth: 0,
        baseHeaders: [
            { text: '', align: 'center', value: 'data-table-select', sortable: false, width: '50px' },
            { text: 'Exercício', align: 'center', value: 'exercicio.ano', width: '100px' },
            { text: 'Código Elemento', align: 'center', value: 'codigo_elemento', width: '150px' },
            { text: 'Descrição', align: 'center', value: 'descricao', width: '300px' },
            { text: 'Status', align: 'center', value: 'ativo', width: '100px' },
        ],
        filters: {
            codigoElementoFilter: '',
            descricaoElementoFilter: '',
            exercicioFilter: null,
            statusFilter: null,
        },
        items: [],
        itemSelected: [],
        modalEdit: false,
        modalCreate: false,
        exerciciosOptions: [],
        statusOptions: [
            { text: 'Todos', value: null },
            { text: 'Ativo', value: true },
            { text: 'Inativo', value: false }
        ],
        showFilters: true,
        page: 1,
        totalItems: 0,
        itemsPerPage: 10,
        loading: false,
        filterTimeout: null
    }),
    computed: {
        isAllSelected() {
            return this.items.length > 0 && this.itemSelected.length === this.items.length;
        },
        isIndeterminate() {
            return this.itemSelected.length > 0 && this.itemSelected.length < this.items.length;
        },
        // Headers computados - sempre mostra todas as colunas
        computedHeaders() {
            // Sempre retorna todas as colunas, independente da resolução
            // O scroll horizontal cuidará da navegação em telas pequenas
            return this.baseHeaders;
        }
    },
    created() {
        this.listarElementosPaginado();
        this.listarExerciciosSelect();
        this.handleResize();
    },
    mounted() {
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        page: async function(newValue) {
            this.page = newValue;
            await this.listarElementosPaginado();
        }
        // Removendo os watchers individuais pois agora usamos handleFilterChange
    },
    methods: {
        async listarElementosPaginado() {
            try {
                this.loading = true;
                const filter = this.prepareFormFilter();

                const response = await ElementoService.index(filter);

                if (typeof response !== 'string') {
                    this.items = response.data.data;
                    this.totalItems = response.data.total;
                    this.itemSelected = [];
                    this.$forceUpdate();
                } else {
                    console.error('Não foi possível obter os elementos.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os elementos:', error);
            } finally {
                this.loading = false;
            }
        },
        async listarExerciciosSelect() {
            try {
                const response = await ExercicioService.select();
                if (response) {
                    this.exerciciosOptions = response.data.map((el) => {
                        return {
                            text: el.ano,
                            value: el.ano,
                        };
                    });
                    this.exerciciosOptions?.unshift({
                        text: "Todos",
                        value: null,
                    });

                } else {
                    console.error('Não foi possível obter os exercícios.');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao listar os exercícios:', error);
            }
        },
        async destroyElementos() {
            try {
                const ids = this.itemSelected.map(elemento => elemento.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("elementos[]", id);
                });

                const response = await ElementoService.destroy(formData);

                if (!response) {
                    console.error('Não foi possível excluir os elementos.');
                }

                this.listarElementosPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao excluir os elementos:', error);
            }
        },
        async activateElementos() {
            try {
                const ids = this.itemSelected.map(elemento => elemento.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("elementos[]", id);
                });

                const response = await ElementoService.activate(formData);

                if (!response) {
                    console.error('Não foi possível ativar os elementos.');
                }

                this.listarElementosPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao ativar os elementos:', error);
            }
        },
        async deactivateElementos() {
            try {
                const ids = this.itemSelected.map(elemento => elemento.id);

                const formData = new FormData();

                ids.forEach(id => {
                    formData.append("elementos[]", id);
                });

                const response = await ElementoService.deactivate(formData);

                if (!response) {
                    console.error('Não foi possível desativar os elementos.');
                }

                this.listarElementosPaginado();
            } catch (error) {
                console.error('Ocorreu um erro ao desativar os elementos:', error);
            }
        },
        openModal(value) {
            if (value == 'create') {
                this.modalCreate = true;
            }
            if (value == 'edit') {
                this.modalEdit = true;
            }
        },
        closeActionsDialog() {
            this.modalCreate = false;
        },

        prepareFormFilter() {
            const filter = new FormData();
            
            if (this.filters.codigoElementoFilter) {
                filter.append("codigo_elemento", this.filters.codigoElementoFilter);
            }
            
            if (this.filters.descricaoElementoFilter) {
                filter.append("descricao", this.filters.descricaoElementoFilter);
            }
            
            if (this.filters.exercicioFilter) {
                filter.append("exercicio", this.filters.exercicioFilter);
            }
            
            if (this.filters.statusFilter !== null) {
                filter.append("ativo", this.filters.statusFilter);
            }
            
            filter.append("page", this.page);
            filter.append("per_page", this.itemsPerPage);
            
            return filter;
        },
        
        // Métodos para o componente StandardPagination
        handlePageChanged(newPage) {
            this.page = newPage;
        },
        
        handleItemsPerPageChanged(newItemsPerPage) {
            this.itemsPerPage = newItemsPerPage;
            this.page = 1;
            this.listarElementosPaginado();
        },
        
        // Métodos para o componente ActionButtons
        navigateToCreate() {
            this.$router.push('/elementos/criar');
        },
        
        navigateToEdit() {
            if (this.itemSelected.length === 1) {
                this.$router.push(`/elemento/editar/${this.itemSelected[0].id}`);
            }
        },
        
        handleExport() {
            this.$globalAlert('Funcionalidade de exportação será implementada em breve!');
        },

        truncateText(text, maxLength) {
            if (!text || text.length <= maxLength) {
                return text;
            }
            return text.substring(0, maxLength) + '...';
        },

        toggleFilters() {
            this.showFilters = !this.showFilters;
        },
        
        clearFilters() {
            this.filters.codigoElementoFilter = '';
            this.filters.descricaoElementoFilter = '';
            this.filters.exercicioFilter = null;
            this.filters.statusFilter = null;
            this.page = 1;
            this.listarElementosPaginado();
        },
        
        handleFilterChange() {
            // Debounce para evitar muitas chamadas à API
            if (this.filterTimeout) {
                clearTimeout(this.filterTimeout);
            }
            
            this.filterTimeout = setTimeout(() => {
                this.page = 1;
                this.listarElementosPaginado();
            }, 300);
        },
        
        toggleSelectAll() {
            if (this.isAllSelected) {
                this.itemSelected = [];
            } else {
                this.itemSelected = [...this.items];
            }
        },

        // Método que estava faltando - para definir classes das linhas da tabela
        getRowClass(item) {
            return item.ativo ? 'row-active' : 'row-inactive';
        },
        
        // Método para detectar mudanças no tamanho da tela
        handleResize() {
            this.windowWidth = window.innerWidth;
            this.isMobile = this.windowWidth < 768;
            this.isTablet = this.windowWidth >= 768 && this.windowWidth < 1024;
        }
    }
};